import React from 'react';
import { reportError } from '../../services/logs/logs.service';
import classes from './base-error-boundary.module.scss';

type AppErrorBoundaryProps = {
  children: React.ReactNode;
};

type AppErrorBoundaryState = {
  hasError: boolean;
};

export class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  constructor(props: AppErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo): void {
    // Keep runtime failures visible in logs while preventing full app crash loops.
    // eslint-disable-next-line no-console
    console.error('Unhandled React render error', error);
    reportError({
      message: error instanceof Error ? error.message : 'Unhandled React render error',
      errorName: error instanceof Error ? error.name : 'RenderError',
      trace: error instanceof Error ? error.stack : undefined,
      context: { componentStack: info.componentStack },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={classes.container}>
          <h1> Congrats! You have reached the secret ERROR </h1>
          <p>Thats wonderfull, it means that you are fired.</p>
          <h1>אתה מפוטר אחי/אחותי, קח את הדברים שלך</h1>
          <h2>אתה לא עושה איתנו לג בעומר</h2>
        </div>
      );
    }

    return this.props.children;
  }
}
